import { FormEvent, useEffect, useState } from "react";
import { Modal, Row, Col, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { defineValueInInput } from "../../../../components/funcForInput";
import removeAllErrorMsg from "../../../../components/funcRemoveAllErros";
import funcSleep from "../../../../components/funcSleep";
import { reqPut, ApiEndpoints, reqPatch, reqPostNew } from "../../../../config/apiClient";

export default function ModalEscalaTipoFormModal({ show, escalaTipo, handleClose, handleUpdate }: iProps) {
    useEffect(() => {
        if (Object.values(escalaTipo).length > 0) {
            carregarDados(escalaTipo);
        }
    }, [escalaTipo]);

    const [loading, setLoading] = useState<boolean>(false);

    async function carregarDados(tipo: any) {
        defineValueInInput("id_tipo", tipo.id_tipo);
        defineValueInInput("descricao", tipo.descricao);
    }

    async function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        event.stopPropagation();

        removeAllErrorMsg();

        const form: any = event.target;
        let formValidado = true;

        let dados = {
            id_tipo: Object.values(escalaTipo).length > 0 ? escalaTipo.id_tipo : null,
            descricao: form.descricao.value,
        };

        if (dados.descricao === "") {
            form.descricao.nextElementSibling.style.display = "block";
            formValidado = false;
        }

        console.log(dados);
        if (!formValidado) {
            return;
        }

        if (dados.id_tipo === null) {
            await cadastrar(dados);
        }
        if (dados.id_tipo > 0) {
            await editar(dados);
        }
    }

    async function cadastrar(dados: any) {
        setLoading(true);
        const api = await reqPut(ApiEndpoints.pontoTiposEscalasCadastrar, dados);
        if (api.status === 201) {
            toast.success("Tipo Escala cadastrada com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(600);
            setLoading(false);
            handleUpdate()
        } else {
            setLoading(false);
        }
    }

    async function editar(dados: any) {
        setLoading(true);
        const api = await reqPatch(ApiEndpoints.pontoTiposEscalasEditar, dados);
        if (api.status === 200) {
            toast.success("Tipo Escala editada com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(600);
            setLoading(false);
            handleUpdate()
        } else {
            setLoading(false);
        }
    }

    async function deletar() { 
        if (!window.confirm("Tem certeza que deseja excluir o tipo de escala?")) { 
            return
        }
        const dados = {
            id_tipo: escalaTipo.id_tipo,
        }
        setLoading(true)
        const api = await reqPostNew(ApiEndpoints.pontoTiposEscalasDeletar, dados)

        if (api.status === 200) { 
            toast.success("Tipo Escala excluída com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(600);
            setLoading(false);
            handleUpdate()
        } else {
            setLoading(false)
        }
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {Object.values(escalaTipo).length === 0 && <b>Cadastrar Tipo Escala</b>}
                    {Object.values(escalaTipo).length > 0 && <b>Editar Tipo Escala</b>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id={`formCriarPasta`} onSubmit={handleSubmit} noValidate>
                    <Row className="mb-15-forms" style={{ display: Object.values(escalaTipo).length > 0 ? "flex" : "none" }}>
                        <Col className="col-12">
                            <Form.Group>
                                <Form.Label>ID:</Form.Label>
                                <Form.Control type="text" name="id_tipo" id="id_tipo" disabled={true} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12">
                            <Form.Group>
                                <Form.Label>Descrição:</Form.Label>
                                <Form.Control type="text" name="descricao" id="descricao" required />
                                <Form.Control.Feedback type="invalid">Informe a descrição!</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br />
                    <div className="div-row">
                        <Button type="submit" variant="success" disabled={loading} style={{ marginRight: "10px" }}>
                            Salvar
                        </Button>
                        <Button variant="danger" onClick={()=>deletar()} disabled={loading} style={{ display: Object.values(escalaTipo).length > 0 ? "flex" : "none" }}>
                            Deletar
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
interface iProps {
    show: boolean;
    escalaTipo: any;
    handleClose: any;
    handleUpdate: any;
}
